export const donorSortByList = [
	{ label: 'Wisely Recommended', rule: 'target_giving_amount' },
	{ label: 'Recently Engaged', rule: 'recency' },
	{ label: 'Needs Attention', rule: 'needs_attention' },
	{ label: 'Alphabetically', rule: 'name' },
];

export const donorsInitialState = {
	entities: {},
	totalToDisplay: 0,
	skip: 0,
	filters: {},
	sortBy: donorSortByList[0],
};

export const donorInitialState = {
	_id: undefined,
	name: '',
	email: {},
	phone: {},
	fundraisers: [],
	tags: [],
};



// WEBPACK FOOTER //
// ./src/redux/donors/donor.initialState.js